<template>
  <div
    v-if="section === currentSection"
    :class="sectionClass"
    :ref="section.name || section"
    :key="section.name"
    :id="'Section_' + section.name"
  >
    <div class="tabdisableoverlay" v-if="section.tabDisabled">
      <h1 class="text-danger font-400">
        <i class="fa fa-ban fa-fw"></i>Zakładka jest wyłączona z edycji
      </h1>
    </div>
    <div v-else-if="section.unlockInfo && section.unlockInfo.length && !section.tabDisabled">
      <h4 class="no-padding margin-bottom-5 text-warning">
        <i class="fa fa-warning fa-fw"></i>Opis wymaganych zmian
      </h4>
      <div class="alert alert-warning" style="white-space: pre-wrap;">{{ section.unlockInfo }}</div>
    </div>

    <h1 v-if="section.description" v-html="section.description"></h1>
    <w-blocker
      v-if="block !== null || isBlocked !== null"
      v-bind="block"
      :model="isBlocked || (block && block.model)"
    >
      <template v-slot:title>
        <slot name="blockTitle" />
      </template>
      <slot />
    </w-blocker>
    <slot v-else />
  </div>
</template>

<script>
import nextListNumber from '@witkac/jschema/lib/methods/nextListNumber';

function renumber(el) {
  // console.time('renumber');
  // console.time('elemget');
  if (!el || !el.getElementsByClassName) {
    return;
  }
  const elems = el.getElementsByClassName('next-number');
  // console.timeEnd('elemget');
  // console.log('elems', elems);
  const levels = [];
  for (let i = 0; i < elems.length; i++) {
    const elem = elems[i];
    // console.log(i, elem.offsetParent);
    if (elem.offsetParent !== null) {
      const dataset = elem.dataset;
      const level = (dataset && dataset.level && +elem.dataset.level) || 0;
      const type = dataset && dataset.type;
      const value = dataset && dataset.value && +dataset.value;

      const s = nextListNumber(levels, level, dataset && dataset.type, value ? value : undefined);

      if (dataset.prevvalue !== s) {
        elem.innerText = s;
        dataset.prevvalue = s;
      }
    }
  }
  // console.timeEnd('renumber');
}

export default {
  name: 'w-section',
  props: {
    section: Object,
    currentSection: Object,
    sectionClass: {
      type: String,
      default: 'smart-form well'
    },
    dynamicNumbers: {
      type: Boolean,
      default: false
    },
    block: {
      type: Object,
      default: null,
      required: false
    },
    isBlocked: {
      type: Boolean,
      default: null,
      required: false
    }
  },
  mounted() {
    if (this.dynamicNumbers) {
      const vm = this;
      this.$nextTick(function() {
        const el = this.$el;
        renumber(el);
      });
    }
  },

  updated() {
    if (this.dynamicNumbers) {
      const vm = this;
      this.$nextTick(function() {
        const el = this.$el;

        renumber(el);
      });
    }
  }
};
</script>

<style scoped>
.tabdisableoverlay {
  left: 0px;
  top: 0px;
  text-align: center;
  right: 0px;
  bottom: 0px;
  padding-top: 10px;
  font-weight: bold;
  position: absolute;
  z-index: 1000;
  opacity: 0.7;
  background-color: white;
}
</style>
